module.exports = __webpack_public_path__ + "static/media/rightarrow.b695090c.svg";